import { AccountHolder } from "@api";

/**
 * @see https://rentablo.atlassian.net/browse/REN-692?focusedCommentId=10696
 * */
export const getNetfondsImportStatus = (
  accountHolders: AccountHolder[]
): boolean | null => {
  if (!accountHolders.length) return null;

  const isAccountHoldersSyncRequired = accountHolders.some(
    ({ isSyncConsentRequired }) => isSyncConsentRequired
  );

  if (isAccountHoldersSyncRequired) return true;

  const hasActiveOrTerminatedSubscriptions = accountHolders.find(
    ({ numberOfActiveOrTerminatedSubscriptions = 0 }) =>
      numberOfActiveOrTerminatedSubscriptions > 0
  );

  if (!hasActiveOrTerminatedSubscriptions) return null;

  const noOneSyncEnabled = accountHolders.every(
    ({ isSyncEnabled }) => isSyncEnabled === false
  );

  if (!noOneSyncEnabled) return null;

  return false;
};
